(function(){
  'use strict';
  if(window.__PMY_FINAL_CHECKOUT_CONTROLS_V3__)return;
  window.__PMY_FINAL_CHECKOUT_CONTROLS_V3__=true;

  var panel=null;
  var activeTrigger=null;
  var uid=0;
  var travelerObserver=null;
  var calCursor=null;

  function byId(id){return document.getElementById(id)}
  function qa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function pad(n){return String(n).padStart(2,'0')}
  function dateKey(y,m,d){return y+'-'+pad(m+1)+'-'+pad(d)}
  function parseKey(v){
    var m=String(v||'').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m?new Date(Number(m[1]),Number(m[2])-1,Number(m[3])):null;
  }
  function formatKey(v){
    var d=parseKey(v);
    return d?(pad(d.getDate())+'/'+pad(d.getMonth()+1)+'/'+d.getFullYear()):'dd/mm/yyyy';
  }
  function chevron(){return '<span class="pmy-final-chevron" aria-hidden="true"></span>'}
  function calendarIcon(){
    return '<svg class="pmy-final-date-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M16 3v4M8 3v4M3 10h18"></path></svg>';
  }
  function flag(code){
    var cc=String(code||'').toUpperCase();
    if(!/^[A-Z]{2}$/.test(cc))return '🌐';
    return String.fromCodePoint(127397+cc.charCodeAt(0),127397+cc.charCodeAt(1));
  }

  function drawer(){return byId('pmy-checkout-drawer')}

  function ensurePanel(){
    var d=drawer();
    if(!d)return null;
    if(panel&&panel.isConnected&&panel.parentElement===d)return panel;
    var existing=byId('pmy-final-dropdown-panel');
    if(existing)existing.remove();
    panel=document.createElement('div');
    panel.id='pmy-final-dropdown-panel';
    d.appendChild(panel);
    return panel;
  }

  function panelIsOpen(){
    var p=ensurePanel();
    return !!(p&&p.classList.contains('is-open'));
  }

  function hidePanel(){
    var p=ensurePanel();
    if(p)p.classList.remove('is-open');
    if(activeTrigger)activeTrigger.setAttribute('aria-expanded','false');
    activeTrigger=null;
  }

  function positionPanel(trigger,width){
    var d=drawer();
    var p=ensurePanel();
    if(!d||!p)return;

    var dr=d.getBoundingClientRect();
    var r=trigger.getBoundingClientRect();
    var margin=10;
    var w=Math.min(Math.max(Number(width)||r.width,r.width),dr.width-(margin*2));
    var left=r.left-dr.left;

    if(left+w>dr.width-margin)left=r.right-dr.left-w;
    left=Math.max(margin,Math.min(left,dr.width-w-margin));

    p.style.width=Math.round(w)+'px';
    p.style.left=Math.round(left)+'px';
    p.style.right='auto';
    p.style.top=Math.round(r.bottom-dr.top+7)+'px';
    p.style.bottom='auto';
    p.classList.add('is-open');

    requestAnimationFrame(function(){
      var pr=p.getBoundingClientRect();
      var usableBottom=dr.bottom-margin;
      var below=usableBottom-r.bottom;
      var above=r.top-dr.top-margin;
      var h=Math.min(pr.height,380);

      if(h>below&&above>below){
        p.style.top=Math.max(margin,Math.round(r.top-dr.top-h-7))+'px';
      }else{
        p.style.top=Math.max(margin,Math.min(dr.height-h-margin,Math.round(r.bottom-dr.top+7)))+'px';
      }
    });
  }

  function clearLegacy(){
    qa('.pmy-select-panel,.pmy-country-panel,.pmy-control-panel').forEach(function(old){old.remove()});
  }

  function removeSiblingShells(select){
    var next=select.nextElementSibling;
    while(next&&(
      next.classList.contains('pmy-select-shell')||
      next.classList.contains('pmy-control-shell')||
      next.classList.contains('pmy-final-select-shell')
    )){
      var kill=next;
      next=next.nextElementSibling;
      kill.remove();
    }
  }

  function syncSelect(select){
    var shell=select.nextElementSibling;
    if(!shell||!shell.classList.contains('pmy-final-select-shell'))return;
    var label=shell.querySelector('.pmy-final-trigger-label');
    var opt=select.options[select.selectedIndex];
    var text=opt?opt.textContent.trim():'';
    /* PMY 2026-10-13: only write when the text really changed.
       Writing textContent always creates a DOM mutation, which re-fired the
       travelers MutationObserver forever and froze the whole page. */
    if(label&&label.textContent!==text)label.textContent=text;
  }

  function isMounted(select){
    var next=select&&select.nextElementSibling;
    return !!(next&&next.classList.contains('pmy-final-select-shell'));
  }

  function mountSelect(select){
    if(!select)return;
    /* Already mounted: never mutate the observed subtree again. */
    if(isMounted(select)){
      syncSelect(select);
      return;
    }
    removeSiblingShells(select);

    select.classList.remove('pmy-native-select');
    select.classList.add('pmy-native-hidden','pmy-final-native');

    if(!select.id){
      uid+=1;
      select.id='pmy-final-native-'+uid;
    }

    var shell=document.createElement('div');
    shell.className='pmy-final-select-shell';
    var trigger=document.createElement('button');
    trigger.type='button';
    trigger.className='pmy-final-trigger';
    trigger.setAttribute('data-pmy-final-select',select.id);
    trigger.setAttribute('aria-haspopup','listbox');
    trigger.setAttribute('aria-expanded','false');
    trigger.innerHTML='<span class="pmy-final-trigger-label"></span>'+chevron();
    shell.appendChild(trigger);
    select.insertAdjacentElement('afterend',shell);

    if(select.dataset.pmyFinalChangeBound!=='1'){
      select.dataset.pmyFinalChangeBound='1';
      select.addEventListener('change',function(){syncSelect(select)});
    }
    syncSelect(select);
  }

  function renderSelect(select,trigger){
    var p=ensurePanel();
    if(!p)return;
    p.className='';
    p.innerHTML='';

    function addOption(opt){
      if(opt.hidden)return;
      var b=document.createElement('button');
      b.type='button';
      b.className='pmy-final-option'+(opt.value===select.value?' is-active':'');
      b.disabled=!!opt.disabled;
      b.textContent=opt.textContent.trim();
      b.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        if(b.disabled)return;
        select.value=opt.value;
        select.dispatchEvent(new Event('input',{bubbles:true}));
        select.dispatchEvent(new Event('change',{bubbles:true}));
        syncSelect(select);
        hidePanel();
      });
      p.appendChild(b);
    }

    Array.prototype.forEach.call(select.children,function(node){
      if(node.tagName==='OPTGROUP'){
        var g=document.createElement('div');
        g.className='pmy-final-group';
        g.textContent=node.label;
        p.appendChild(g);
        Array.prototype.forEach.call(node.children,addOption);
      }else if(node.tagName==='OPTION'){
        addOption(node);
      }
    });

    trigger.setAttribute('aria-expanded','true');
    activeTrigger=trigger;
    var width=Math.max(trigger.getBoundingClientRect().width,select.classList.contains('traveler-time-select')?300:220);
    positionPanel(trigger,width);
  }

  function ensureDdi(){
    var phone=byId('chk-phone-number');
    var wrap=phone&&phone.closest('.pmy-checkout-phone');
    if(!wrap)return;

    var old=byId('phone-prefix-trigger');
    if(old)old.remove();

    var btn=document.createElement('button');
    btn.id='phone-prefix-trigger';
    btn.type='button';
    btn.className='pmy-final-ddi';
    btn.setAttribute('data-pmy-final-ddi','1');
    btn.setAttribute('aria-haspopup','listbox');
    btn.setAttribute('aria-expanded','false');

    var api=window.PMYPhoneCountry;
    var current=api&&typeof api.get==='function'?api.get():null;
    var code=current?current.c:'PT';
    var prefix=current?current.p:'+351';

    btn.innerHTML='<span id="prefix-flag">'+flag(code)+'</span><span id="prefix-code">'+prefix+'</span>'+chevron();
    wrap.insertBefore(btn,phone);
  }

  function ddiCountries(){
    var api=window.PMYPhoneCountry;
    if(api&&typeof api.list==='function')return api.list();
    return Array.isArray(window.PMY_COUNTRIES)?window.PMY_COUNTRIES:[];
  }

  function ddiCurrent(){
    var api=window.PMYPhoneCountry;
    return api&&typeof api.get==='function'?api.get():null;
  }

  function renderDdi(trigger){
    var p=ensurePanel();
    if(!p)return;
    p.className='pmy-final-ddi-panel';
    p.innerHTML='<div class="pmy-final-search"><input type="search" autocomplete="off" placeholder="Search country or DDI"></div><div class="pmy-final-ddi-list"></div>';

    var search=p.querySelector('input');
    var list=p.querySelector('.pmy-final-ddi-list');

    function fill(){
      var q=String(search.value||'').toLowerCase().trim();
      var digits=q.replace(/\D/g,'');
      var current=ddiCurrent();
      list.innerHTML='';

      ddiCountries().filter(function(c){
        return !q||
          String(c.c||'').toLowerCase().indexOf(q)!==-1||
          String(c.n||'').toLowerCase().indexOf(q)!==-1||
          String(c.p||'').toLowerCase().indexOf(q)!==-1||
          (digits&&String(c.p||'').replace(/\D/g,'').indexOf(digits)!==-1);
      }).forEach(function(c){
        var b=document.createElement('button');
        b.type='button';
        b.className='pmy-final-option pmy-final-ddi-row'+(current&&current.c===c.c?' is-active':'');
        b.innerHTML='<span>'+flag(c.c)+'</span><span class="pmy-final-country-code">'+c.c+'</span><span class="pmy-final-country-name">'+c.n+'</span><span class="pmy-final-country-prefix">'+c.p+'</span>';
        b.addEventListener('click',function(e){
          e.preventDefault();
          e.stopPropagation();
          var api=window.PMYPhoneCountry;
          if(api&&typeof api.set==='function')api.set(c.c);
          var now=ddiCurrent()||c;
          var fresh=byId('phone-prefix-trigger');
          if(fresh){
            var f=fresh.querySelector('#prefix-flag');
            var pc=fresh.querySelector('#prefix-code');
            if(f)f.textContent=flag(now.c);
            if(pc)pc.textContent=now.p;
          }
          hidePanel();
        });
        list.appendChild(b);
      });
    }

    search.addEventListener('input',fill);
    search.addEventListener('click',function(e){e.stopPropagation()});
    fill();

    trigger.setAttribute('aria-expanded','true');
    activeTrigger=trigger;
    positionPanel(trigger,300);
    setTimeout(function(){search.focus()},20);
  }

  function mountDate(){
    var input=byId('chk-date');
    if(!input)return;
    qa('.pmy-date-trigger,.pmy-date-control,.pmy-final-date',input.parentElement).forEach(function(el){el.remove()});
    if(input._flatpickr){
      try{input._flatpickr.destroy()}catch(e){}
    }

    input.type='text';
    input.readOnly=true;
    input.classList.add('pmy-native-hidden','pmy-final-native');

    var btn=document.createElement('button');
    btn.type='button';
    btn.className='pmy-final-date';
    btn.setAttribute('data-pmy-final-date','1');
    btn.setAttribute('aria-haspopup','dialog');
    btn.setAttribute('aria-expanded','false');
    btn.innerHTML='<span class="pmy-final-date-label">'+formatKey(input.value)+'</span>'+calendarIcon();
    input.insertAdjacentElement('afterend',btn);
  }

  function isBlocked(key){
    var d=parseKey(key);
    if(!d)return true;
    var today=new Date();
    today.setHours(0,0,0,0);
    if(d<today)return true;
    return !!(window.PMYCheckoutDrawer&&typeof window.PMYCheckoutDrawer.isDateBlocked==='function'&&window.PMYCheckoutDrawer.isDateBlocked(key));
  }

  function monthLabel(y,m){
    try{
      return new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'long',year:'numeric'}).format(new Date(y,m,1));
    }catch(e){
      return new Date(y,m,1).toLocaleString('en',{month:'long',year:'numeric'});
    }
  }

  function renderCalendar(trigger){
    var input=byId('chk-date');
    var selected=parseKey(input&&input.value);
    if(!calCursor){
      calCursor=selected?new Date(selected.getFullYear(),selected.getMonth(),1):new Date(new Date().getFullYear(),new Date().getMonth(),1);
    }

    var y=calCursor.getFullYear();
    var m=calCursor.getMonth();
    var first=new Date(y,m,1);
    var days=new Date(y,m+1,0).getDate();
    var start=first.getDay();
    var today=new Date();
    today.setHours(0,0,0,0);

    var p=ensurePanel();
    if(!p)return;
    p.className='pmy-final-calendar-panel';
    p.innerHTML='';

    var head=document.createElement('div');
    head.className='pmy-final-cal-head';
    var prev=document.createElement('button');
    prev.type='button';
    prev.className='pmy-final-cal-nav';
    prev.innerHTML='‹';
    var title=document.createElement('div');
    title.className='pmy-final-cal-title';
    title.textContent=monthLabel(y,m);
    var next=document.createElement('button');
    next.type='button';
    next.className='pmy-final-cal-nav';
    next.innerHTML='›';
    head.append(prev,title,next);
    p.appendChild(head);

    var week=document.createElement('div');
    week.className='pmy-final-cal-week';
    ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].forEach(function(day){
      var s=document.createElement('span');
      s.textContent=day;
      week.appendChild(s);
    });
    p.appendChild(week);

    var grid=document.createElement('div');
    grid.className='pmy-final-cal-grid';
    for(var e=0;e<start;e++){
      var empty=document.createElement('span');
      empty.className='pmy-final-cal-empty';
      grid.appendChild(empty);
    }

    for(var day=1;day<=days;day++){
      (function(dayNum){
        var key=dateKey(y,m,dayNum);
        var d=new Date(y,m,dayNum);
        var b=document.createElement('button');
        b.type='button';
        b.className='pmy-final-cal-day';
        b.textContent=String(dayNum);
        if(d.getTime()===today.getTime())b.classList.add('is-today');
        if(input&&input.value===key)b.classList.add('is-selected');
        if(isBlocked(key))b.disabled=true;
        b.addEventListener('click',function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if(b.disabled)return;
          input.value=key;
          input.dispatchEvent(new Event('change',{bubbles:true}));
          var label=trigger.querySelector('.pmy-final-date-label');
          if(label)label.textContent=formatKey(key);
          hidePanel();
        });
        grid.appendChild(b);
      })(day);
    }
    p.appendChild(grid);

    prev.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      calCursor=new Date(y,m-1,1);
      renderCalendar(trigger);
    });
    next.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      calCursor=new Date(y,m+1,1);
      renderCalendar(trigger);
    });

    trigger.setAttribute('aria-expanded','true');
    activeTrigger=trigger;
    positionPanel(trigger,324);
  }

  function mount(){
    var d=drawer();
    if(!d)return false;

    clearLegacy();
    mountSelect(byId('tour-dropdown'));
    mountSelect(byId('checkout-lang-select'));
    mountSelect(byId('checkout-time-select'));
    qa('.traveler-time-select',d).forEach(mountSelect);
    ensureDdi();
    mountDate();
    ensurePanel();

    var travelers=byId('dynamic-travelers-container');
    if(travelers&&!travelerObserver){
      /* PMY 2026-10-13: watch only the rows added to the container (no subtree),
         and only mount selects that are not mounted yet. Our own shell/label
         changes happen deeper in the tree, so they can never re-trigger this. */
      travelerObserver=new MutationObserver(function(){
        qa('.traveler-time-select',travelers).forEach(function(select){
          if(!isMounted(select))mountSelect(select);
        });
      });
      travelerObserver.observe(travelers,{childList:true});
    }
    return true;
  }

  document.addEventListener('click',function(e){
    var trigger=e.target.closest&&e.target.closest('[data-pmy-final-select]');
    if(trigger){
      e.preventDefault();
      e.stopPropagation();
      var select=byId(trigger.getAttribute('data-pmy-final-select'));
      if(!select)return;
      var same=panelIsOpen()&&activeTrigger===trigger;
      hidePanel();
      if(!same)renderSelect(select,trigger);
      return;
    }

    var ddi=e.target.closest&&e.target.closest('[data-pmy-final-ddi]');
    if(ddi){
      e.preventDefault();
      e.stopPropagation();
      var sameDdi=panelIsOpen()&&activeTrigger===ddi;
      hidePanel();
      if(!sameDdi)renderDdi(ddi);
      return;
    }

    var date=e.target.closest&&e.target.closest('[data-pmy-final-date]');
    if(date){
      e.preventDefault();
      e.stopPropagation();
      var sameDate=panelIsOpen()&&activeTrigger===date;
      hidePanel();
      if(!sameDate){
        calCursor=null;
        renderCalendar(date);
      }
      return;
    }

    if(!drawer())return;
    var p=ensurePanel();
    if(p&&panelIsOpen()&&!p.contains(e.target))hidePanel();
  },true);

  document.addEventListener('keydown',function(e){if(e.key==='Escape')hidePanel()});
  /* PMY 2026-10-15: on phones the on-screen keyboard resizes the window. That
     closed the DDI list as soon as the search box got focus, so nobody could
     search a country. Only close on a real width change, and never while the
     visitor is typing inside the open panel. */
  var lastWidth=window.innerWidth;
  function typingInPanel(){
    var a=document.activeElement;
    return !!(a&&panel&&panel.contains(a));
  }
  window.addEventListener('resize',function(){
    var w=window.innerWidth;
    if(w===lastWidth||typingInPanel())return;
    lastWidth=w;
    hidePanel();
  },{passive:true});

  document.addEventListener('pmy:checkout-final-refresh',function(){setTimeout(mount,0)});
  document.addEventListener('pmy:checkout-product-change',function(){setTimeout(mount,10)});
  document.addEventListener('shopify:section:load',function(){setTimeout(mount,20)});

  var tries=0;
  function boot(){
    tries++;
    if(!mount()&&tries<80)setTimeout(boot,100);
    var body=document.querySelector('#pmy-checkout-drawer .pmy-checkout-drawer__body');
    if(body&&body.dataset.pmyFinalScrollBound!=='1'){
      body.dataset.pmyFinalScrollBound='1';
      body.addEventListener('scroll',function(){if(!typingInPanel())hidePanel()},{passive:true});
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
